import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Schema} from "@/common/Schema";
import {Cloneable} from "@/common/Cloneable";
import {RepeatInterval} from "@/modules/redactor/models/guard/RepeatInterval";


export class GuardTimeRule extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(GuardTimeRule, v) : SKIP;
            },
            (v) => {
                return deserialize(GuardTimeRule, v);
            }
        );
    }

    constructor() {
        super();

        this._launchTime = 0;
        this._pendingTime = 0;
        this._repeatInterval = RepeatInterval.NONE;
    }

    get launchTime() {
        return this._launchTime;
    }

    set launchTime(value) {
        this._launchTime = value;
    }

    get pendingTime() {
        return this._pendingTime;
    }

    set pendingTime(value) {
        this._pendingTime = value;
    }

    get repeatInterval() {
        return this._repeatInterval;
    }

    set repeatInterval(value) {
        this._repeatInterval = value;
    }

    valid() {

        if (!RepeatInterval.is(this.repeatInterval)) {
            return false;
        }

        if (!Number.isInteger(this.launchTime) || this.launchTime < 0) {
            return false;
        }

        if (!Number.isInteger(this.pendingTime) || this.pendingTime < 0) {
            return false;
        }

        return true;
    }

    empty() {
        return this.launchTime === 0 && this.pendingTime === 0 && RepeatInterval.isNone(this.repeatInterval);
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new GuardTimeRule());
        } else if (target instanceof GuardTimeRule) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(GuardTimeRule, {
    _launchTime: alias("launch_time", Schema.primitive()),
    _pendingTime: alias("pending_time", Schema.primitive()),
    _repeatInterval: alias("repeat_interval", RepeatInterval.schema())
});